import { BlockTransformContext, StoryblokBlock } from '~/lib/storyblok'

export async function transformChefMenuBlock(block: StoryblokBlock, { props, options }: BlockTransformContext) {
  return {
    ...props,
    title: block.title,
    richtext: block.richtext,
    options: {
      ...options,
      order: block.option_order || 'text_image',
    },
  }
}
